import React, {useState} from 'react';
import {CircularProgress, Box} from "@material-ui/core";
import {StopoverButton} from "../../../../index";
import {t} from 'ttag';
import {useSelector} from "react-redux";
import {BOOK_STOPOVER_WITH_EXPERIENCES_FORM_REF} from "../../common/book-form-input-refs";
import {SW_FLIGHT_TYPES} from "../../../../../store/types";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

const BookStopoverWithExperiencesConnected = () => {

    const [submitting, setSubmitting] = useState(false);
    const currentLanguage = useSelector(state => state.app.currentLanguage);
    const origin = useSelector(state => state.sw.book.origin);
    const destination = useSelector(state => state.sw.book.destination);
    const departure = useSelector(state => state.sw.book.departure);
    const arrival = useSelector(state => state.sw.book.arrival);
    const flightType = useSelector(state => state.sw.book.flightType);
    const isRoundTrip = flightType === SW_FLIGHT_TYPES.RETURN;

    const canSubmit = (() => {
        switch (flightType) {
            case SW_FLIGHT_TYPES.RETURN:
                return origin
                    && destination
                    && departure
                    && arrival;
            case SW_FLIGHT_TYPES.ONE_WAY:
                return origin
                    && destination
                    && departure;
            default:
                return false;
        }
    })();

    const langMarket = (() => {
        // AzoresGetaways.com country to market map
        switch (origin?.countryCode) {
            case 'CA':
                return `${currentLanguage}-ca`;
            case 'PT':
                return `${currentLanguage}-pt`;
            case 'GB':
                return `${currentLanguage}-uk`;
            case 'DK':
            case 'NO':
            case 'SE':
            case 'FI':
                return `${currentLanguage}-ne`;
            default:
                return `${currentLanguage}-us`;
        }
    })();

    const form = (() => {
        if (!canSubmit) return null;
        return (
            <form method={'GET'}
                  action={`${process.env.REACT_APP_STOPOVER_EXPERIENCES_SUBMIT_URL}/${langMarket}/search/deals`}
                  target={'_blank'}
                  ref={BOOK_STOPOVER_WITH_EXPERIENCES_FORM_REF}>
                <input type={'hidden'} name={'departureAirport'} value={origin?.code || ''}/>
                <input type={'hidden'} name={'freeText'} value={destination?.code || ''}/>
                <input type={'hidden'} name={'departureDate'} value={departure || ''}/>
                {isRoundTrip && <input type={'hidden'} name={'returnDate'} value={arrival || ''}/>}
                <input type={'hidden'} name={'flexibility'} value={'3'}/>
                <input type={'hidden'} name={'ref'} value={'Deals Search Results'}/>
                <input type={'hidden'} name={'interests[]'} value={'unique_experiences'}/>
                <input type={'hidden'} name={'affiliateCode'} value={'azoresairlines'}/>
            </form>
        );
    })();

    const submitHandler = () => {
        try {
            //setSubmitting(true);
            BOOK_STOPOVER_WITH_EXPERIENCES_FORM_REF.current.submit();
        } catch (e) {
            setSubmitting(false);
        }
    };

    return (
        <Box display={'flex'} justifyContent={'center'}>
            {canSubmit && form}
            <StopoverButton
                title={t`Stopover`}
                subtitle={t`with Experiences`}
                disabled={Boolean(!canSubmit || submitting)}
                onClick={submitHandler}
                icon={submitting ? <CircularProgress/> : <ArrowForwardIosIcon/>}
            />
        </Box>
    );
};

export default BookStopoverWithExperiencesConnected;